import { lazy } from "react";
import Loadable from "app/components/Loadable";
import LoanOfficer from "./LoanOfficer";

const loanofficer = Loadable(lazy(() => import("./LoanOfficer")));

const loanofficerRoute = [{ path: "/loanofficer", element: <LoanOfficer /> }];
export default loanofficerRoute;
